import React from "react";
import ImageViewer from "./ImageViewer/ImageViewer";
import axios from "axios";
import {API_URL} from "../constants";
import {authHeader} from "../Utilities";

export class SampleViewer extends React.Component {
  render() {

    return (
        <ImageViewer
            projectId={this.props.match.params.projectId}
            editable={true}
            hierarchiesAllowed={false}
            commentsAllowed={false}
            history={this.props.history}
            location={this.props.location}
            loadAnnotation={() => {
              return axios.get(
                  API_URL + `/projects/${this.props.match.params.projectId}/samples/${this.props.match.params.sampleId}`,
                  {headers: authHeader()}
              );
            }}

            saveChanges={(annotation) => {
              return axios.put(API_URL + `/projects/${this.props.match.params.projectId}/samples/${this.props.match.params.sampleId}`,
                {
                  annotation: annotation
                },
                {headers: authHeader()}
              )
            }}
        />
    )
  }
}